import React from "react";
import {setChosenDay} from "../../../../../slices/statisticsSlice";
import DatePicker, {registerLocale} from "react-datepicker";
import {DatepickerHeader} from "./DatePickerHeader";
import {useDispatch, useSelector} from "react-redux";
import {getLanguage} from "../../../../../locales/langUtils";
import {flip, shift} from "@floating-ui/react";
import {DatePickerTrigger} from "./DatePickerTrigger";

import pl from "date-fns/locale/pl";
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import uk from "date-fns/locale/uk";
import {useWindowWidth} from "../../../../../hooks/useWindowWidth";

const DATEPICKER_LOCALES = {
    en: {code: "en", locale: enUS},
    pl: {code: "pl", locale: pl},
    es: {code: "es", locale: es},
    de: {code: "de", locale: de},
    fr: {code: "fr", locale: fr},
    uk: {code: "uk", locale: uk},
};

Object.values(DATEPICKER_LOCALES).forEach(({code, locale}) => {
    registerLocale(code, locale);
});

export const CustomDatePicker = ({restaurantCreation}) => {
    const dispatch = useDispatch();
    const {chosenDay} = useSelector(state => state.statistics.view);
    const rawLanguage = getLanguage() || 'en';
    const language = rawLanguage.split('-')[0];
    const selectedLocale = DATEPICKER_LOCALES[language] || DATEPICKER_LOCALES.en;
    const windowWidth = useWindowWidth()
    const isMobile = windowWidth <= 550;

    const popperModifiers = () => {
        return isMobile
            ? undefined
            : [
                flip({
                    fallbackPlacements: ['bottom-start', 'top-end', 'top-start'],
                    padding: 8,
                }),
                shift({padding: 8}),
            ]
    }

    return (
        <DatePicker selected={chosenDay ? new Date(chosenDay) : new Date()}
                    onChange={(date) => {
                        if (date) {
                            dispatch(setChosenDay(date.toISOString()));
                        }
                    }}
                    customInput={<DatePickerTrigger/>}
                    locale={selectedLocale.code}
                    dateFormat="d MMMM yyyy"
                    wrapperClassName={'datepicker-custom-wrapper'}
                    className={'datepicker-custom-input'}
                    calendarClassName={'datepicker-custom-calendar'}
                    popperClassName={'datepicker-custom-popper'}
                    maxDate={new Date()}
                    minDate={restaurantCreation}
                    showPopperArrow={false}
                    showMonthYearDropdown={false}
                    withPortal={isMobile}
                    popperPlacement={isMobile ? 'bottom-start' : 'bottom-end'}
                    popperModifiers={popperModifiers()}
                    renderCustomHeader={({
                                             date,
                                             decreaseMonth,
                                             increaseMonth,
                                             prevMonthButtonDisabled,
                                             nextMonthButtonDisabled,
                                         }) => (
                        <DatepickerHeader
                            date={date}
                            decreaseMonth={decreaseMonth}
                            increaseMonth={increaseMonth}
                            prevMonthButtonDisabled={prevMonthButtonDisabled}
                            nextMonthButtonDisabled={nextMonthButtonDisabled}
                            localeObject={selectedLocale.locale}
                        />
                    )}
        />
    );
};